// Generates a Superhive API token from the extension-install modal.
// The secret is returned once by POST /account/api_tokens (JSON) and displayed
// for copy/paste into Blender; it is never retrievable again.
import { requestApiToken, defaultTokenName } from "./request_token"

function generateApiToken(event) {
  requestApiToken(event, {
    errorSelector: ".js-generate-api-token-error",
    scopePreset: "extensions",
    failureMessage: "Could not generate a token.",
    tokenName: defaultTokenName,
    onSuccess: function ($modal, data) {
      $modal.find("#generatedApiToken").text(data.secret)
      $modal.find(".js-generate-api-token-intro").addClass("d-none")
      $modal.find(".js-generate-api-token-result").removeClass("d-none")
    },
  })
}

$(document).on("turbolinks:load", function () {
  $(".js-generate-api-token").on("click", generateApiToken)
})
